import styled from '@emotion/styled';
import { mq } from '@hrworks/design-system';
import { Logo as _Logo, LogoStyles } from '@hrworks/sui-core/Logo';

import { S as SqwLayoutStyles } from '../SqwLayout.styles';

const Container = styled.div(({ theme }) => ({
  display: 'flex',
  height: SqwLayoutStyles.componentConfig.header.height,
  padding: `0 ${SqwLayoutStyles.componentConfig.sidebar.horizontalPadding}px`,
  alignItems: 'center',
  justifyContent: 'center',
  width: SqwLayoutStyles.componentConfig.sidebar.width,
  backgroundColor: theme.sqwTier2Color.background.nav.default,
  borderRight: `1px solid ${theme.sqwTier2Color.border.nav.subtle}`,
  gap: theme.marko.variables.spacing.distance.medium,
  flexShrink: 0,

  [mq.isSmallDevice]: {
    borderRight: 'none',
    justifyContent: 'start',
  },
}));

const Logo = styled(_Logo)({
  [`${LogoStyles.Logo}`]: {
    maxWidth: SqwLayoutStyles.componentConfig.header.logoWidth,
  },
});

export const S = {
  Container,
  Logo,
};
